import script from "./UpdateStatusLog.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpdateStatusLog.vue?vue&type=script&setup=true&lang=ts"

import "./UpdateStatusLog.vue?vue&type=style&index=0&id=9fb92a60&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9fb92a60"]])

export default __exports__